/* eslint-disable react-hooks/exhaustive-deps */
import * as React from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { FormControl } from './index';
import { find, debounce } from 'lodash';
import { CircularProgress, FormHelperText } from '@mui/material';
import axiosInstance from 'src/utils/axios';
import PropTypes from 'prop-types';

const MuiAutocompletecustom = (props) => {
  const {
    name,
    label,
    forceLoading,
    value,
    url,
    country_data,
    state_id,
    stateurl,
    cityurl,
    required,
    fullWidth,
    helperText,
    disabled,
    getOptionLabel,
    getOptionValue,
    filter,
  } = props;

  const [loading, setLoading] = React.useState(false);
  const [search, setSearch] = React.useState('');
  const [options, setOptions] = React.useState([]);

  React.useEffect(() => {
    getCountryData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    getCountryData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  React.useEffect(() => {
    if (country_data !== undefined) {
      getStateData(country_data);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, country_data]);

  React.useEffect(() => {
    if (state_id !== undefined) {
      getCityData(state_id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, state_id]);

  React.useEffect(() => {
    if (value) {
      const defaultValue = find(options, { value: Number(value) });
      if (defaultValue) {
        setSearch(defaultValue.label);
      }
    }
  }, [value, options]);

  const getLabel = (element) => {
    if (element && element[getOptionLabel]) {
      return element[getOptionLabel];
    } else {
      return '';
    }
  };

  const getValue = (element) => Number(element[getOptionValue]);

  const getCountryData = async (search = null) => {
    setLoading(true);

    const params = {
      search: search,
      page: 1,
      pageSize: 10,
      defaultValue: value,
    };

    if (filter) {
      filter.forEach((element) => {
        params[element.field] = element.value;
      });
    }

    let options = [];

    await axiosInstance
      .get(url, { params })
      .then((response) => {
        if (response.status === 200) {
          if (response.data.data) {
            response.data.data.forEach((element) => {
              options.push({
                label: getLabel(element),
                value: getValue(element),
              });
            });
            setOptions(options);
          }
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const getStateData = async (country_data) => {
    setLoading(true);
    const params = {
      search: search,
      page: 1,
      pageSize: 10,
      country_id: country_data,
      defaultValue: value,
    };

    if (filter) {
      filter.forEach((element) => {
        params[element.field] = element.value;
      });
    }

    let options = [];

    await axiosInstance
      .get(stateurl, { params })
      .then((response) => {
        if (response.status === 200) {
          if (response.data.data) {
            response.data.data.forEach((element) => {
              options.push({
                label: getLabel(element),
                value: getValue(element),
              });
            });
            setOptions(options);
          }
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const getCityData = async (state_id) => {
    setLoading(true);

    const params = {
      search: search,
      page: 1,
      pageSize: 10,
      defaultValue: value,
      state_id: state_id,
    };

    if (filter) {
      filter.forEach((element) => {
        params[element.field] = element.value;
      });
    }

    let options = [];

    await axiosInstance
      .get(cityurl, { params })
      .then((response) => {
        if (response.status === 200) {
          if (response.data.data) {
            response.data.data.forEach((element) => {
              options.push({
                label: getLabel(element),
                value: getValue(element),
              });
            });
            setOptions(options);
          }
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  React.useEffect(() => {
    if (forceLoading === true) {
      getCountryData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [forceLoading]);

  React.useEffect(() => {
    if (filter) {
      getCountryData();
      setSearch('');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  React.useEffect(() => {
    if (forceLoading === true) {
      getStateData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [forceLoading]);

  React.useEffect(() => {
    if (filter) {
      getStateData();
      setSearch('');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  React.useEffect(() => {
    if (forceLoading === true) {
      getCityData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [forceLoading]);

  React.useEffect(() => {
    if (filter) {
      getCityData();
      setSearch('');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  const delayedCountryQuery = React.useCallback(debounce(getCountryData, 1000), []);
  const delayedCityQuery = React.useCallback(debounce(getStateData, 1000), []);
  const delayedStateQuery = React.useCallback(debounce(getCityData, 1000), []);

  const handleOnChange = (value) => {
    setSearch(value);
    delayedCountryQuery(value);
    delayedCityQuery(value);
    delayedStateQuery(value);
  };

  const setValue = (option) => {
    if (option) {
      props.onChange(option.value);
    } else {
      props.onChange(null);
    }
  };

  const defaultValue = find(options, { value: Number(value) });

  return (
    <FormControl key={`key${name}`} error={helperText ? true : false} fullWidth={fullWidth} required={required}>
      <Autocomplete
        disabled={disabled}
        options={options}
        defaultValue={defaultValue}
        autoHighlight
        loading={loading}
        inputValue={search}
        onInputChange={(event, newInputValue) => {
          if (event?.type === 'change') {
            handleOnChange(newInputValue);
          }
        }}
        onChange={(event, newValue) => {
          if (event?.type === 'click') {
            setValue(newValue);
            if (newValue == null) {
              setSearch('');
            }
          }
        }}
        renderOption={(props, option) => (
          <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
            {option.label}
          </Box>
        )}
        renderInput={(params) => (
          <TextField
            error={helperText ? true : false}
            {...params}
            label={label}
            inputProps={{
              ...params.inputProps,
              autoComplete: 'off', // disable autocomplete and autofill
              endAdornment: (
                <React.Fragment>
                  {loading ? <CircularProgress color="inherit" size={20} /> : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
      />
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

MuiAutocompletecustom.defaultProps = {
  variant: 'outlined',
  fullWidth: true,
  required: false,
  disabled: false,
  helperText: null,
  forceLoading: false,
  getOptionLabel: 'label',
  getOptionValue: 'value',
  filter: null,
  onChange: () => {},
};

MuiAutocompletecustom.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  url: PropTypes.string,
  country_data: PropTypes.string,
  state_id: PropTypes.number,
  stateurl: PropTypes.string,
  cityurl: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  required: PropTypes.bool,
  fullWidth: PropTypes.bool,
  helperText: PropTypes.string,
  disabled: PropTypes.bool,
  forceLoading: PropTypes.bool,
  getOptionLabel: PropTypes.string,
  getOptionValue: PropTypes.string,
  filter: PropTypes.array,
  variant: PropTypes.string,
  onChange: PropTypes.func,
};

export default MuiAutocompletecustom;
